import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLockOpen32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconLockOpen32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M14.19 5.17c-.81.175-1.52.488-1.922.97a10 10 0 0 0-.666.876q-.075.118-.088.145l-.002.004a1 1 0 0 1-1.84-.785l.928.375a99 99 0 0 1-.927-.376l.001-.002.002-.004.003-.008.007-.016a2 2 0 0 1 .066-.135 4 4 0 0 1 .174-.289c.155-.239.405-.585.806-1.065.829-.995 2.072-1.437 3.034-1.645a10 10 0 0 1 2.164-.217h.051l.105.002A6.914 6.914 0 0 1 23 9.914V11a4 4 0 0 1 4 4v9a4 4 0 0 1-4 4H9a4 4 0 0 1-4-4v-9a4 4 0 0 1 4-4h12V9.914C21 7.2 18.8 5 16.086 5c-.052 0-.107 0-.151-.002H15.9a8 8 0 0 0-1.71.172M22 13h1a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2zm-5.031 7.75a2 2 0 1 0-1.938 0q-.03.12-.031.25v1a1 1 0 1 0 2 0v-1q0-.13-.031-.25"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLockOpen32);
